/**
 * Coalesces a burst of calls (window resize, capture-phase scroll) into one
 * run per animation frame, so a layout read + setState happens at most once
 * per painted frame instead of once per event.
 *
 * Usage:
 *   const measure = frameThrottle(() => { ... })
 *   window.addEventListener('resize', measure)
 *   return () => { window.removeEventListener('resize', measure); measure.cancel() }
 */
export function frameThrottle(fn: () => void): (() => void) & { cancel: () => void } {
  let frame = 0
  const run = () => {
    if (frame) return
    frame = requestAnimationFrame(() => {
      frame = 0
      fn()
    })
  }
  run.cancel = () => {
    if (frame) cancelAnimationFrame(frame)
    frame = 0
  }
  return run
}
